(function () {
  function initMobileMenu() {
    var toggle = document.querySelector('[data-rng-menu-toggle]');
    var menu = document.querySelector('[data-rng-mobile-menu]');
    if (!toggle || !menu) return;

    toggle.addEventListener('click', function () {
      var isOpen = !menu.classList.contains('hidden');
      menu.classList.toggle('hidden', isOpen);
      toggle.setAttribute('aria-expanded', String(!isOpen));
    });
  }

  function setHeaderScrollState(header, scrolled) {
    if (scrolled) {
      header.classList.remove('bg-transparent');
      header.classList.add('bg-cream/95', 'backdrop-blur-md', 'shadow-sm', 'is-scrolled');
    } else {
      header.classList.remove('bg-cream/95', 'backdrop-blur-md', 'shadow-sm', 'is-scrolled');
      header.classList.add('bg-transparent');
    }

    updateHeaderScrollState(header, scrolled);
  }

  function initHeaderScroll() {
    var header = document.querySelector('[data-rng-header]');
    if (!header || header.dataset.transparent !== 'true') return;

    var overlay = document.querySelector('[data-rng-hero], [data-rng-page-banner]');
    if (!overlay) return;

    function syncHeaderState() {
      var heroBottom = overlay.getBoundingClientRect().bottom;
      setHeaderScrollState(header, heroBottom <= 96);
    }

    syncHeaderState();

    var observer = new IntersectionObserver(
      function () {
        syncHeaderState();
      },
      { threshold: [0, 0.1, 0.25], rootMargin: '-96px 0px 0px 0px' }
    );

    observer.observe(overlay);

    if (window.rngLenis) {
      window.rngLenis.on('scroll', syncHeaderState);
    } else {
      window.addEventListener('scroll', syncHeaderState, { passive: true });
    }

    window.addEventListener('resize', syncHeaderState);
  }

  function updateHeaderScrollState(header, scrolled) {
    var logo = header.querySelector('[data-rng-header-logo]');
    var logoOnLight = header.dataset.logoOnLight;
    var logoOnDark = header.dataset.logoOnDark;

    if (logo && logoOnLight && logoOnDark) {
      logo.src = scrolled ? logoOnLight : logoOnDark;
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMobileMenu();
    initHeaderScroll();
  });
  document.addEventListener('shopify:section:load', function () {
    initMobileMenu();
    initHeaderScroll();
  });
})();
